import React, { useState } from "react";
import { Form, Row, Col, Modal, Button } from "react-bootstrap";

const ChangeConsentModal = ({ toggleConsent, showConsentModal, closeConsentModal }) => {
  const [consentMesage, setConsentMesage] = useState("");

  const sendPass = async status => {
    if (status === "takenConsent") {
      toggleConsent();
    }
    try {
      // const r = await ApiService.sendSendPass(
      // {
      //     kitId: props.kitId,
      //     consentMesage: status,
      // })
      // props.closeConsentModal()
    } catch (error) {
      alert("Error while sending appointment request. Try again later.");
      console.error(error);
    } finally {
      closeConsentModal();
    }
  };

  return (
    <Modal size="lg" show={showConsentModal} onHide={() => closeConsentModal} backdrop={"static"}>
      <Modal.Body style={{ textAlign: "center" }}>
        <Row>
          <Col>
            <p style={{ fontSize: 24, fontWeight: 800 }}>Are you sure you want to change the consent status ?</p>
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col>
            <Button variant="light"  className="rounded-sm" size="lg" onClick={() => sendPass("takenConsent")}>
              I’ve taken the consent from patient
            </Button>
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col>
            <Button variant="dark" className="rounded-sm" size="lg" onClick={() => sendPass("askPatient")}>
              Ask Patient to update pass status
            </Button>
          </Col>
        </Row>
        <hr />
        <Button onClick={closeConsentModal} variant="light">
          Cancel
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeConsentModal;
